import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import RelatedPosts from "./RelatedPosts";
import { usePageTitle } from "../utils/usePageTitle";

function SinglePost() {
  const location = useLocation();
  const path = location.pathname.split("/")[3];

  const [post, setPost] = useState(null);

  const pageName = post?.title || "Article";
  usePageTitle(pageName);

  useEffect(() => {
    fetch(`https://dev.to/api/articles/${path}`)
      .then((res) => res.json())
      .then((res) => {
        setPost(res);
      });
  }, [path]);

  if (!post) {
    return (
      <div className="max-w-4xl mx-auto px-6 py-16 text-center text-purple-600">
        Loading post...
      </div>
    );
  }

  return (
    <article className="max-w-4xl mx-auto px-6 py-12 font-sans text-slate-800">
      {/* Tags */}
    <ul className="flex flex-wrap gap-2 mb-4 text-sm font-light">
        {(post.tag_list
            ? typeof post.tag_list === "string"
            ? post.tag_list.split(",").map((tag) => tag.trim())
            : Array.isArray(post.tag_list)
            ? post.tag_list
            : []
            : []
        ).length > 0 ? (
            (post.tag_list
            ? typeof post.tag_list === "string"
                ? post.tag_list.split(",").map((tag) => tag.trim())
                : Array.isArray(post.tag_list)
                ? post.tag_list
                : []
            : []
            ).map((tag, i) => (
            <li
                key={i}
                className="bg-purple-50 text-purple-700 px-2 py-0.5 rounded"
            >
                #{tag}
            </li>
            ))
        ) : (
            <li className="text-sm text-slate-500 italic">No tags</li>
        )}
    </ul>


      {/* Title */}
      <h1 className="text-4xl font-bold mb-4 text-purple-800">{post.title}</h1>

      {/* Post Meta */}
      <ul className="flex flex-wrap gap-6 mb-6 text-sm text-slate-500">
        <li>Published on {post.readable_publish_date}</li>
        <li>{post.reading_time_minutes} min read</li>
        <li>
          Originally published{" "}
          <a
            href={post.url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-purple-600 hover:underline"
          >
            on dev.to
          </a>
        </li>
      </ul>

      {/* Cover Image */}
      {post.cover_image && (
        <a
          href={post.url}
          target="_blank"
          rel="noopener noreferrer"
          className="block mb-8"
        >
          <img
            src={post.cover_image}
            alt={post.title}
            className="w-full rounded-lg shadow-md object-cover max-h-96"
          />
        </a>
      )}

      {/* Post Body */}
        <div
        className="prose prose-purple max-w-none text-slate-700
             prose-img:mx-auto prose-img:my-6 prose-img:rounded-xl
             prose-img:block
             prose-ul:list-disc prose-ul:pl-6 prose-li:my-1
             prose-code:bg-slate-700 prose-code:text-purple-100 prose-code:font-semibold prose-code:text-sm prose-code:px-1.5 prose-code:py-0.5 prose-code:rounded
             prose-pre:bg-slate-700 prose-pre:text-purple-100 prose-pre:rounded-lg prose-pre:p-4 prose-pre:overflow-x-auto"
        dangerouslySetInnerHTML={{ __html: post.body_html }}
        />

        {/* Related Posts */}
        <RelatedPosts currentPost={post} />
    </article>
  );
}

export default SinglePost;
